import type { AuthedRequester } from "@/lib/brokerAuth";

// The broker's marketing-communication consent seam — `/api/broker/consent`
// (PMS-S346). The TWO-AXIS model: consent (this) is the per-purpose MARKETING
// permission, deliberately separate from the transactional preferences
// (brokerNotificationPreferences) — withdrawing marketing never affects
// transactional delivery. Consumed by the preference center (BRK-S158).

const BASE = "/api/broker/consent";

export type MarketingChannel = "email" | "sms";

export interface MarketingChannelConsent {
  channel: MarketingChannel;
  granted: boolean;
  version: number | null;
  updatedAt: string | null;
}

export interface MarketingConsentView {
  channels: MarketingChannelConsent[];
}

/** GET — the broker's own marketing consent, per push channel. */
export function getMarketingConsent(
  request: AuthedRequester,
): Promise<MarketingConsentView> {
  return request<MarketingConsentView>(BASE);
}

/** PUT — grant or withdraw marketing consent for one channel; returns the
 *  refreshed view. */
export function setMarketingConsent(
  request: AuthedRequester,
  input: { channel: MarketingChannel; granted: boolean },
): Promise<MarketingConsentView> {
  return request<MarketingConsentView>(BASE, { method: "PUT", body: input });
}
